export const timeZoneOptions = [
  { label: 'UTC', value: 0 },
  { label: 'EST', value: -5 },
  { label: 'CST', value: -6 },
  { label: 'MST', value: -7 },
  { label: 'PST', value: -8 },
  { label: 'AKST', value: -9 },
  { label: 'HST', value: -10 },
  { label: 'CET', value: 1 },
  { label: 'EET', value: 2 },
  { label: 'JST', value: 9 },
  { label: 'AEST', value: 10 },
];

/**
 * Get the timezone label for a given UTC offset
 *
 * @param offset - UTC offset in hours (e.g., -5 for EST, -8 for PST)
 * @returns Timezone label (e.g., 'EST', 'PST') or formatted UTC offset
 */
export const getTimezoneLabel = (offset: number): string => {
  const tzOption = timeZoneOptions.find((tz) => tz.value === offset);
  return tzOption?.label ?? `UTC${offset >= 0 ? '+' : ''}${offset}`;
};
